module.exports = __webpack_public_path__ + "img/monocycle-green-right.c6e7f9a7.jpg";